import type { ProcessorInfo } from './types';

/** Admits the i7-14700K and i9; excludes the i3-12100 (4) and every i5 (6). */
export const MIN_P_CORES_FOR_INTENSIVE_AI = 8;

/** Matches the i3-12100, so an uninspectable host fails the gate. */
export const ASSUMED_P_CORES_WHEN_UNDETECTABLE = 4;

/** An absent count is the unknown host, and fails closed. */
export function intensiveAIFeaturesAllowed(
  pCores: number | null | undefined,
): boolean {
  return (
    (pCores ?? ASSUMED_P_CORES_WHEN_UNDETECTABLE) >=
    MIN_P_CORES_FOR_INTENSIVE_AI
  );
}

/** Reported when the processor could not be determined. */
export const UNKNOWN_PROCESSOR: ProcessorInfo = {
  modelName: null,
  physicalCores: null,
  pCores: ASSUMED_P_CORES_WHEN_UNDETECTABLE,
  eCores: null,
  threads: null,
};
